export default {
  experimentId: '100',
  serverUrl: 'https://re-veil-backend-83c42dec8100.herokuapp.com//',
  socketUrl: 'wss://re-veil-backend-83c42dec8100.herokuapp.com//socket',
  // this will be used in prolific mode
  completionUrl: 'https://app.prolific.com/submissions/complete?cc=CGYULV9Z',
  contactEmail: 'cui.ding@uzh.ch',
  uploadUrl: 'https://drive.switch.ch/index.php/s/wlfkWdmKr6eoqSH',
  // Either 'debug', 'directLink' or 'prolific'
  mode: 'prolific',
  language: 'zh'
};